import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { colors, fonts, spacing, borderRadius, shadows } from '../../../constants';

/**
 * SectionCard Component
 * Reusable section card wrapper
 * 
 * @param {string} title - Section title
 * @param {React.ReactNode} children - Section content
 */
const SectionCard = ({ title, children }) => (
  <Paper
    elevation={0}
    sx={{
      p: spacing.sm,
      borderRadius: borderRadius.lg,
      border: `1px solid ${colors.borderDefault}`,
      background: 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,249,250,0.85) 100%)',
      transition: 'all 0.25s ease-in-out',
      boxShadow: shadows.md,
      overflow: 'visible',
      '&:hover': {
        boxShadow: shadows.lg,
        borderColor: colors.primaryDark,
      },
    }}
  >
    <Typography
      variant="h6"
      component="h3"
      sx={{
        fontWeight: fonts.weightSemiBold,
        fontSize: fonts.fontSizeLg,
        color: '#1b2538',
        mb: spacing.xs,
        pb: '8px',
        borderBottom: `1px solid #e5e7eb`,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {title}
    </Typography>
    <Box sx={{ mt: '4px', width: '100%' }}>
      {children}
    </Box>
  </Paper>
);

export default SectionCard;
